// extracted by mini-css-extract-plugin
module.exports = {"chip":"keyword_chip-module__chip--144-K","label":"keyword_chip-module__label--2vcCm","selected":"keyword_chip-module__selected--2CMg8","close":"keyword_chip-module__close--2CigP"};